var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('router-link',{staticClass:"btn dealers_btn mr-3",staticStyle:{"font-size":"15px"},attrs:{"to":{name: 'salesDetails', query: {branchId: _vm.data.branchId, date: _vm.data.date, branchName: _vm.data.branchName, saleId: _vm.data.id, ..._vm.$route.query}}}},[_vm._v("\n    "+_vm._s(_vm.$t('text.clickButtons.viewDetails'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }